/**
 * /frontend/src/features/analytics/hooks/useWhatIfAnalytics.js
 */

import { useCallback, useMemo } from 'react';
import { getWhatIfHours, getWhatIfSections, getWhatIfStaff } from '../api/whatIfAnalyticsApi';
import useAnalyticsResource from './useAnalyticsResource';

/**
 * Loads what-if analytics data.
 * @param {Object} params
 * @returns {{data:any,isLoading:boolean,isError:boolean,error:any,refetch:Function}}
 */
const useWhatIfAnalytics = (params = {}) => {
  const { request, storeToken, storeUuid, refreshSignal } = params;
  const enabled = Boolean(request && storeUuid);

  const fetcher = useCallback(async () => {
    const [sections, staff, hours] = await Promise.all([
      getWhatIfSections(request, storeToken, storeUuid, 0, 0),
      getWhatIfStaff(request, storeToken, storeUuid, 0, 0),
      getWhatIfHours(request, storeToken, storeUuid, 0, 0),
    ]);
    return { sections, staff, hours };
  }, [request, storeToken, storeUuid]);

  const resource = useAnalyticsResource(enabled, fetcher, 'useWhatIfAnalytics', refreshSignal);
  return useMemo(() => resource, [resource]);
};

export default useWhatIfAnalytics;
